import styled from 'styled-components/native';

export default styled.View`
  margin-left: ${({ theme }) => (theme.media.tablet ? '40px' : 0)};
  padding: 12px 0;
  flex-direction: column;
`;
